import { LabelSize as FluentLabelSize, LabelWeight as FluentLabelWeight } from "@fluentui/web-components";
/** Size values for {@link Label}. */
export const LabelSizes = { ...FluentLabelSize };
/** Weight values for {@link Label}. */
export const LabelWeights = { ...FluentLabelWeight };
//# sourceMappingURL=label.options.js.map